<div class="chatContainer">
  <div class="chatContainer__list">
    <vc-chat-list
      class="chatContainer__list__wrapper"
      [channelId]="selectedChannelId"
      (channelSelected)="onSelectChannelId($event)"
    ></vc-chat-list>
  </div>
  <vc-chat-discussion class="chatContainer__discussion" [channelId]="selectedChannelId"></vc-chat-discussion>
</div>
